(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpDatabox', cpDatabox);

    cpDatabox.$inject = [];

    function cpDatabox() {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/caffeprint/directives/databox/databox.html',
            scope: {
                title: '@',
                titleInfo: '@?',
                object: '=',
                rows: '=',
                onClick: '&?',
                showBadge: '=?'
            },
            link: function(scope, element, attrs, controller) {
                scope.getValue = getValue;

                function getValue(obj, row) {
                    return row.value.split(".").reduce(function(result, key) {
                        return result && result[key] ? result[key] : '';
                    }, obj) || row.defaultValue;
                }
            }
        };
    }
})();
